import http from "@/helper/http";
import api from "@/helper/api";

const defaultPurchaseOrders = () => ({
  items: [],
  total: 0,
  page: 1,
  pages: 0,
});

export default {
  state: {
    purchaseOrders: defaultPurchaseOrders(),
    purchaseOrder: null,
    loadingPurchaseOrders: false,
    loadingCreatePurchaseOrder: false,
    loadingUpdatePurchaseOrder: false,
    loadingSendPurchaseOrder: false,
    loadingCancelPurchaseOrder: false,
  },
  mutations: {
    SET_PURCHASE_ORDERS(state, payload) {
      state.purchaseOrders = payload || defaultPurchaseOrders();
    },
    SET_PURCHASE_ORDER(state, payload) {
      state.purchaseOrder = payload || null;
    },
    SET_LOADING_PURCHASE_ORDERS(state, value) {
      state.loadingPurchaseOrders = !!value;
    },
    SET_LOADING_CREATE_PURCHASE_ORDER(state, value) {
      state.loadingCreatePurchaseOrder = !!value;
    },
    SET_LOADING_UPDATE_PURCHASE_ORDER(state, value) {
      state.loadingUpdatePurchaseOrder = !!value;
    },
    SET_LOADING_SEND_PURCHASE_ORDER(state, value) {
      state.loadingSendPurchaseOrder = !!value;
    },
    SET_LOADING_CANCEL_PURCHASE_ORDER(state, value) {
      state.loadingCancelPurchaseOrder = !!value;
    },
    RESET_PURCHASE_ORDERS_STATE(state) {
      state.purchaseOrders = defaultPurchaseOrders();
      state.purchaseOrder = null;
    },
  },
  actions: {
    async listPurchaseOrders(
      { commit },
      { storeId, page = 1, per_page = 10, query = "", supplier_id, status, start_date, end_date }
    ) {
      if (!storeId) {
        commit("RESET_PURCHASE_ORDERS_STATE");
        throw new Error("A storeId is required to list purchase orders");
      }

      commit("RESET_PURCHASE_ORDERS_STATE");
      commit("SET_LOADING_PURCHASE_ORDERS", true);
      try {
        const params = { page, per_page, query };
        if (supplier_id) params.supplier_id = supplier_id;
        if (status) params.status = status;
        if (start_date) params.start_date = start_date;
        if (end_date) params.end_date = end_date;
        const { data } = await http.get(api.purchase_orders(storeId), { params });
        commit("SET_PURCHASE_ORDERS", data);
        return data;
      } catch (error) {
        commit("RESET_PURCHASE_ORDERS_STATE");
        throw error;
      } finally {
        commit("SET_LOADING_PURCHASE_ORDERS", false);
      }
    },
    async createPurchaseOrder({ commit }, { storeId, payload }) {
      commit("SET_LOADING_CREATE_PURCHASE_ORDER", true);
      try {
        const { data } = await http.post(api.purchase_orders(storeId), payload);
        return data;
      } finally {
        commit("SET_LOADING_CREATE_PURCHASE_ORDER", false);
      }
    },
    async getPurchaseOrder({ commit }, { storeId, orderId }) {
      const { data } = await http.get(api.purchase_order(storeId, orderId));
      commit("SET_PURCHASE_ORDER", data);
      return data;
    },
    async updatePurchaseOrder({ commit }, { storeId, orderId, patch }) {
      commit("SET_LOADING_UPDATE_PURCHASE_ORDER", true);
      try {
        const { data } = await http.patch(
          api.purchase_order(storeId, orderId),
          patch
        );
        commit("SET_PURCHASE_ORDER", data);
        return data;
      } finally {
        commit("SET_LOADING_UPDATE_PURCHASE_ORDER", false);
      }
    },
    async sendPurchaseOrder({ commit }, { storeId, orderId }) {
      commit("SET_LOADING_SEND_PURCHASE_ORDER", true);
      try {
        const { data } = await http.post(
          api.purchase_order_send(storeId, orderId)
        );
        return data;
      } finally {
        commit("SET_LOADING_SEND_PURCHASE_ORDER", false);
      }
    },
    async cancelPurchaseOrder({ commit }, { storeId, orderId }) {
      commit("SET_LOADING_CANCEL_PURCHASE_ORDER", true);
      try {
        const { data } = await http.post(
          api.purchase_order_cancel(storeId, orderId)
        );
        return data;
      } finally {
        commit("SET_LOADING_CANCEL_PURCHASE_ORDER", false);
      }
    },
  },
  getters: {
    purchaseOrders: (state) => state.purchaseOrders,
    purchaseOrder: (state) => state.purchaseOrder,
    loadingPurchaseOrders: (state) => state.loadingPurchaseOrders,
    loadingCreatePurchaseOrder: (state) => state.loadingCreatePurchaseOrder,
    loadingUpdatePurchaseOrder: (state) => state.loadingUpdatePurchaseOrder,
    loadingSendPurchaseOrder: (state) => state.loadingSendPurchaseOrder,
    loadingCancelPurchaseOrder: (state) => state.loadingCancelPurchaseOrder,
  },
};
